import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const GetMasterReport = (requestType, reqBody) => {
  console.log("testdata", requestType);

  // Changes by Arun
  let urlPath =
    requestType == "SCORE" ? "getMasterReport" : "getMasterReportExcelFormat";
  // let headers = !reqBody.isDownloadExcel
  //   ? {
  //       headers: { requestType: requestType },
  //     }
  //   : {
  //       headers: { requestType: requestType },
  //       responseType: "blob",
  //     };
  return axios
    .post(`${URL}/${urlPath}`, reqBody, {
      headers: { requestType: requestType },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetMasterReportExcelFormat = (data) => {
  return axios
    .post(`${URL}/getMasterReportExcelFormat`, data)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetPaidReceivedReport = (requestType, reqBody) => {
  // console.log("reqBody ", reqBody);
  return axios
    .post(`${URL}/getPaidReceivedReport`, reqBody, {
      headers: { requestType: requestType },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const downloadBookingReport = (reqBody) => {
  return axios
    .post(`${URL}/downloadBookingReport`, reqBody)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const GetTDSReport = (requestType, selectedDate) => {
  const headers = {
    requestType: requestType,
    selectedDate: JSON.stringify(selectedDate),
  };

  if (Array.isArray(selectedDate) && selectedDate.length > 0) {
    headers.startdate = selectedDate[0];
    headers.enddate = selectedDate[1] || selectedDate[0];
  }

  return axios
    .get(`${URL}/getTDSReport`, {
      headers: headers,
    })
    .then((response) => {
      const res = response.data;

      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Changes by Gokul
const DeletePolicyReportData = (_id) => {
  return axios
    .delete(`${URL}/deletePaidRecievedReport/${_id}`)
    .then((response) => {
      const resp = response.data;
      if (resp.error) {
        console.log(resp.error);
      } else {
        ToastError(resp.message);
        return resp;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Changes by Gokul
const UpdatePolicyReportData = (_id, updatedData) => {
  return axios
    .put(`${URL}/updatePaidRecievedReport/${_id}`, updatedData)
    .then((response) => {
      const resp = response.data;
      if (resp.error) {
        ToastError(resp.error);
      } else {
        ToastSuccess(resp.message);
        return resp;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetPolicyChequeReport = (reqBody) => {
  return axios
    .post(`${URL}/getPolicyChequeReport`, reqBody)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetDashboard = (dateData) => {
  return axios
    .get(`${URL}/getDashboard`, {
      headers: {
        startdate: dateData.startDate,
        enddate: dateData.endDate,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Added by Arun
const getDashboardPolicyRelatedData = (dateData) => {
  return axios
    .get(`${URL}/getDashboardPolicyRelatedData`, {
      headers: {
        startdate: dateData.startDate,
        enddate: dateData.endDate,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Added by Arun
const getGirnarAPIToken = (dateData) => {
  return axios
    .get(`${URL}/getGirnarAPIToken`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.error(response);
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetBookingReport = (reqBody) => {
  return axios
    .post(`${URL}/getBookingReport`, reqBody)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const GetDashboardDiagramData = () => {
  return axios.get(`${URL}/dashboard/diagram-data`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetDashboardRenewalPolicyData = () => {
  return axios.get(`${URL}/dashboard/renewal-policy-data`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

/**
 * The Dashboard (2026-10-22 redesign): everything the login's role may see, in one call.
 * from / to are India days ("2026-10-01"); fresh skips the server's 30-second cache (the live refresh).
 * Resolves to the summary; a failure is THROWN with words for the person (the page shows them with Retry).
 */
const GetDashboardSummary = ({ from, to, fresh } = {}) =>
  axios
    .get(`${URL}/dashboard/summary`, { params: { from, to, ...(fresh ? { fresh: 1 } : {}) } })
    .then((response) => {
      const res = response.data || {};
      if (res.error || !res.data) throw new Error(res.message || "Could not load the dashboard. Please try again.");
      return res.data;
    })
    .catch((error) => {
      if (error && !error.isAxiosError && !error.request) throw error; // our own words, from above
      throw new Error("Could not reach the server. Check the connection and try again.");
    });

export {
  GetMasterReport,
  GetDashboardSummary,
  GetPaidReceivedReport,
  GetTDSReport,
  GetPolicyChequeReport,
  GetBookingReport,
  UpdatePolicyReportData,
  DeletePolicyReportData,
  GetDashboard,
  getDashboardPolicyRelatedData,
  GetMasterReportExcelFormat,
  getGirnarAPIToken,
  downloadBookingReport,
  GetDashboardDiagramData,
  GetDashboardRenewalPolicyData,
};
